// TO DO: Refactor using already defined variables
export function getPlanNameForTracking(plan: string) {
    const PLANS = {
        ESSENTIAL: 'essential',
        ESSENTIAL_SEMESTRAL: 'essential',
        PREMIUM: 'premium',
        PREMIUM_SEMESTRAL: 'premium',
        UNIQUE_PLAN: 'promo',
    }

    return PLANS[plan] || 'essential';
}

export function getPriceForTracking(plan: string) {
    const PLANS = {
        ESSENTIAL: 24.99,
        ESSENTIAL_SEMESTRAL: 124.95,
        PREMIUM: 39.99,
        PREMIUM_SEMESTRAL: 199.95,
        UNIQUE_PLAN: 119.99,
    }

    return PLANS[plan] || 24.99;
}
